import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRequirementMast } from "../../../models/RequirementMast";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useRef, useState } from "react";
import { ICityMastDropdown, IClientCompanyDropdown, ICountryMastDropdown, IStateMastDropdown, IUniversityDropdown, IVisaDropdown } from "../../../models/IDropdown";
import { Controller, useForm } from "react-hook-form";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmptySubmission } from "../EmptySubmission";
import { NoticePeriod, Experience, Tax_Term, Payment_Term, Submission_Type } from "../../../models/FDropdown";
import { IConsultantMast, IConsultantRef, TaxTerm } from "../../../models/ConsultantMast";
import { JVInputCheck } from "../../../shared/JVInputCheck";
import { AutoComplete } from "primereact/autocomplete";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IClientContactPerson } from "../../../models/ClientContactPerson";
import { IRecruiterRequirements } from "../../../models/RecruiterRequirements";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { Req } from "../../../shared/Req";
import { baseUrl } from "../../../shared/Fetch";
import { JVInputMask } from "../../../shared/JVInputMask";
import { IConsSubmission, SubmissionsTable } from "./SubmissionsTable";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { ILogin } from "../../../models/Login";
import { EmployerDetails } from "./EmployerDetails";
import { SpeechToText } from "./SpeechToText";
import { Slider } from "primereact/slider";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { Tooltip } from "primereact/tooltip";
import { InputTextarea } from "primereact/inputtextarea";

interface Iprops {
  singleData: IRecruiterRequirements;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  ShowCelebration: () => void;
  publish?: boolean;
}

interface IEscalationList {
  id?: number;
  pO_ID?: number;
  vendor_Type?: number;
  vendor_Company_ID?: number;
  vendor_Company_Name?: string;
  added_By?: string;
  company?: string;
  branch?: string;
  escalation_Subject?: string;
  escalation_Comment?: string;
  escalation_Status?: string;
  added_On?: Date;
  updated_By?: string;
  updated_On?: Date;
}

export interface IReqRepoDetailsLst {
  type?: string;
  noOfReq?: number;
  noOfSub?: number;
  noOfECS?: number;
  noOfECI?: number;
  noOfPO?: number;
}

export interface IReqRepoDetails {
  poC_Company?: {
    noOfReq?: number;
    noOfSub?: number;
    noOfECS?: number;
    noOfECI?: number;
    noOfPO?: number;
  };
  poc?: {
    noOfReq?: number;
    noOfSub?: number;
    noOfECS?: number;
    noOfECI?: number;
    noOfPO?: number;
  };
  poC_Sales?: {
    noOfReq?: number;
    noOfSub?: number;
    noOfECS?: number;
    noOfECI?: number;
    noOfPO?: number;
  };
}

interface IBypass {
  openModelStatus?: boolean;
  consultant_ID?: number;
  pO_ID?: number;
}

const emailSchema = yup.object().shape({
  email: yup.string().required().email(),
});
const idSchema = yup.object().shape({
  id: yup.number().required().min(1),
});

const schema = yup.object({
  consultant_Name: yup.string().required(),
  consultant_Email_ID: yup.string().required().email(),
  consultant_Home_No: yup.string().required(),
  consultant_Job_Title: yup.string().required(),
  visa_Status: yup.number().min(1).required(),
  visa_Received_By: yup.object().when("visa_Status", (val) => {
    return val === 4
      ? yup.number().nullable()
      : yup.number().min(1, "Visa Received By is required").required("Visa Received By is required").typeError("Visa Received By is required");
  }),
  state: yup.object().shape({
    state_ID: yup.number().min(1, "State is required*").required("State is required*"),
    state_Name: yup.string().required(),
  }),
  city: yup.object().shape({
    city_ID: yup.number().min(1, "City is required*").required("City is required*"),
    city_Name: yup.string().required(),
  }),
  total_Experience: yup.number().min(1).required(),
  availability: yup.string().required(),
  faceToFaceInterview: yup.boolean().required(),
  hourly_Rate: yup.number().required(),
  tax_Term: yup.number().required().min(1, "Tax Term is required*"),
  payment_Term: yup.number().when("tax_Term", (val) => {
    return val === TaxTerm.Tax_1099_All_Inclusive || val === TaxTerm.Tax_1099_With_Benefits || val === TaxTerm.W2_All_Inclusive || val === TaxTerm.W2_With_Benefits ? yup.number().min(1).required("Payment Term is Required").nullable() : yup.number().nullable();
  }),
  contact_Person_EmailID: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().email().required() : yup.string();
  }),
  company: yup.object().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive
      ? yup.object().shape({
        vendor_Company_ID: yup.number().min(1, "Employer Company is required*").required("Employer Company is required*"),
        vendor_Company_Name: yup.string().required(),
      })
      : yup.object().shape({
        vendor_Company_ID: yup.number(),
        vendor_Company_Name: yup.string(),
      });
  }),
  contact_Person_Name: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().required() : yup.string();
  }),
  phone_No: yup.string().when("tax_Term", (val) => {
    return val === TaxTerm.C2C_With_Benefits || val === TaxTerm.C2C_All_Inclusive ? yup.string().required() : yup.string();
  }),

  degree: yup.string(),
  university_Name: yup.string(),
  passoutYear: yup.string(),
  country: yup.object().shape({
    country_ID: yup.number(),
    country_Name: yup.string(),
  }),
  ssn: yup.string(),
  linkedin: yup.string().url().nullable(),
  submissionType: yup.number().optional().nullable(),
  annual_Salary: yup.string(),

  r1_Ref_ID: yup.number().nullable(),
  r1_Company_Name: yup.string().nullable(),
  r1_POC_Name: yup.string().nullable(),
  r1_Phone: yup.string().nullable(),
  r1_Email: yup.string().email("invalid email").nullable(),

  r2_Ref_ID: yup.number().nullable(),
  r2_Company_Name: yup.string().nullable(),
  r2_POC_Name: yup.string().nullable(),
  r2_Phone: yup.string().nullable(),
  r2_Email: yup.string().email("invalid email").nullable(),

  r3_Ref_ID: yup.number().nullable(),
  r3_Company_Name: yup.string().nullable(),
  r3_POC_Name: yup.string().nullable(),
  r3_Phone: yup.string().nullable(),
  r3_Email: yup.string().email("invalid email").nullable(),
});

export const Submission = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [refCount, setRefCount] = useState(1);
  const [data, setData] = useState<IRequirementMast>();
  const [sliderValue, setSliderValue] = useState<number | null>(null);
  const [reqRepoData, setReqRepoData] = useState({ data: [], loading: false } as { data: IReqRepoDetailsLst[]; loading: boolean });
  const [understoodText, setUnderstoodText] = useState<string | null>(null);
  const [understoodAudioFile, setUnderstoodAudioFile] = useState<File | any | null>(null);
  const [openBlack, setOpenBlack] = useState(false);
  const [openBlackReasonModal, setOpenBlackReasonModal] = useState(false);
  const [openEscalationModal, setOpenEscalationModal] = useState({ singleData: {}, open: false } as { singleData: IEscalationList; open: boolean });
  const [escalationTableData, setEscalationTableData] = useState({ tableData: [], loading: false } as { tableData: IEscalationList[]; loading: boolean });

  const [cities, setCities] = useState<Array<ICityMastDropdown>>();
  const [states, setStates] = useState<Array<IStateMastDropdown>>();
  const [countries, setCountries] = useState<Array<ICountryMastDropdown>>();
  const [visa, setVisa] = useState<Array<IVisaDropdown>>();
  const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
  const [universities, setUniversities] = useState<Array<IUniversityDropdown>>();
  const [university, setUniversity] = useState<IUniversityDropdown | undefined | string>(undefined);
  const [additionInfo, setAdditionInfo] = useState("");
  const [disableEmployeeDetails, setDisableEmployeeDetails] = useState(false);
  const [disablePaymentsTerm, setDisablePaymentsTerm] = useState(true);
  const [resumeFile, setResumeFile] = useState<File | null | any>(null);
  const [visaFile, setVisaFile] = useState<File | null | any>(null);
  const [disableConsultant, setDisableConsultant] = useState(true);
  const [is_Blacklisted, setIs_Blacklisted] = useState<boolean>(false);

  const [subTable, setSubTable] = useState({ data: [], open: false } as { data: Array<IConsSubmission>; open: boolean });
  const [employerDetails, setEmployerDetails] = useState({ data: [], open: false, consultant_ID: 0 } as { data: Array<any>; open: boolean; consultant_ID: number | undefined });

  const {
    control: reasonControl,
    handleSubmit: reasonSubmit,
    formState: { errors: reasonErrors },
    reset: resetReason,
  } = useForm({
    defaultValues: { Requested_Reason: "" },
  });

  const Visa_Received_By = [
    { name: "--SELECT--", value: 0 },
    { name: "Candidate", value: 1 },
    { name: "Subvendor", value: 2 }
  ];

  useEffect(() => {
    if (props.singleData.req_ID) loadData();
  }, [props.singleData.req_ID]);

  const loadData = async () => {
    const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.singleData.req_ID}`, props.toast);
    if (response) {
      const data: IRequirementMast = await response.json();
      setData(data);
    }
  };


  const { control, handleSubmit, watch, formState: { errors }, reset, setValue, } = useForm<IConsultantMast>({
    resolver: yupResolver(schema),
    defaultValues: EmptySubmission,
    shouldFocusError: false,
  });

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "tax_Term") {
        if (value.tax_Term === TaxTerm.C2C_With_Benefits || value.tax_Term === TaxTerm.C2C_All_Inclusive) {
          setDisableEmployeeDetails(false);
        } else {
          setDisableEmployeeDetails(true);
        }
      }
      if (name === "tax_Term") {
        if (value.tax_Term === TaxTerm.Tax_1099_All_Inclusive || value.tax_Term === TaxTerm.Tax_1099_With_Benefits || value.tax_Term === TaxTerm.W2_All_Inclusive || value.tax_Term === TaxTerm.W2_With_Benefits) {
          setDisablePaymentsTerm(false);
        } else {
          setDisablePaymentsTerm(true);
        }
      }
      if (name === "company") {
        if (value.company?.vendor_Company_ID !== undefined && value.company?.vendor_Company_ID !== null && value.company?.vendor_Company_ID !== 0 && value.company?.vendor_Company_ID > 0) {
          loadEscalationTableData(value.company?.vendor_Company_ID);
          setValue("vendor_Company_ID", value.company?.vendor_Company_ID);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  const hideSubTable = () => {
    setSubTable({ data: subTable.data, open: false });
    setEmployerDetails({ data: [], open: false, consultant_ID: 0 });
  };

  useEffect(() => {
    if (university) {
      let un: string | undefined = undefined;
      if (typeof university === "string") {
        un = university;
      } else {
        un = university?.university_Name;
      }
      setValue("university_Name", un);
    } else {
      setValue("university_Name", undefined);
    }
  }, [university]);

  const loadCities = async (filter: string | null) => {
    if (control._formValues.state?.state_ID) {
      const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
      if (response) {
        const data: Array<ICityMastDropdown> = await response.json();
        setCities(data);
      }
    } else {
      props.toast.current.show({ severity: "error", detail: "Select the State First.", life: 3000 });
    }
  };
  const completeMethodCities = (event: { query: string }) => {
    loadCities(event.query);
  };

  const loadStates = async (filter: string | null) => {
    const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<IStateMastDropdown> = await response.json();
      setStates(data);
    }
  };
  const completeMethodStates = (event: { query: string }) => {
    loadStates(event.query);
  };

  const loadCountries = async (filter: string | null) => {
    const response = await Fetch("Dropdown/countries", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<ICountryMastDropdown> = await response.json();
      setCountries(data);
    }
  };
  const completeMethodCountries = (event: { query: string }) => {
    loadCountries(event.query);
  };

  const loadClientCompanies = async (filter: string | null) => {
    const response = await Fetch("Dropdown/vendor_companies_emp_details", "GET", null, `filter=${encodeURIComponent(JSON.stringify(filter))}`, null);
    if (response) {
      const data: Array<IClientCompanyDropdown> = await response.json();
      setClientCompanies(data);
    }
  };
  const completeMethodEC = (event: { query: string }) => {
    loadClientCompanies(event.query);
  };

  const loadVisa = async () => {
    const response = await Fetch("Dropdown/visa", "GET", null, null, null);
    if (response) {
      const data: Array<IVisaDropdown> = await response.json();
      setVisa(data);
    }
  };

  const loadUniversities = async (filter: string | null) => {
    const response = await Fetch("Dropdown/universities", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<IUniversityDropdown> = await response.json();
      setUniversities(data);
    }
  };
  const completeMethodUniversities = (event: { query: string }) => {
    loadUniversities(event.query);
  };

  useEffect(() => {
    loadVisa();
  }, []);

  const loadEscalationTableData = async (companyID: number) => {
    setEscalationTableData({ tableData: escalationTableData.tableData, loading: true });
    const response = await Fetch("vwPODetails/getVendorEscalation", "GET", null, `poID=0&companyID=${companyID}`, props.toast);
    if (response) {
      const data: IEscalationList[] = await response.json();
      setEscalationTableData({ tableData: data, loading: false });
    } else setEscalationTableData({ tableData: escalationTableData.tableData, loading: false });
  };

  const fillSubVendor = async () => {
    setLoading(true);
    const email = control._formValues.contact_Person_EmailID;
    if (email === "") return;
    if (!(email?.includes("gmail") || email?.includes("outlook") || email?.includes("protonmail") || email?.includes("aol") || email?.includes("yahoo") || email?.includes("hotmail") || email?.includes("rediff"))) {
      const valid = await emailSchema.isValid({ email: email });
      if (valid) {
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/email", "GET", null, `email=${email}`, props.toast);
        if (response) {
          const data: Array<IClientContactPerson> = await response.json();

          if (data.length > 0) {
            setValue("contact_Person_EmailID", data[0].contact_Person_EmailID);
            setValue("contact_Person_Name", data[0].contact_Person_Name);
            setValue("phone_No", data[0].phone_No);
            setValue("vendor_Company_ID", data[0].vendor_Company_ID);
            setValue("company", { vendor_Company_ID: data[0].vendor_Company_ID, vendor_Company_Name: data[0].vendor_Company_Name });
            loadEscalationTableData(data[0].vendor_Company_ID || 0);
          } else {
            setValue("contact_Person_Name", "");
            setValue("phone_No", undefined);
            setValue("vendor_Company_ID", undefined);
            setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: "" });
            props.toast.current.show({ severity: "info", content: "No Employer Found resistered with this Email-ID" });
          }
        }
      } else props.toast.current.show({ severity: "error", content: "Please Enter a Valid Employer Email-ID" });
    } else {
      setValue("contact_Person_Name", "");
      setValue("phone_No", undefined);
      setValue("vendor_Company_ID", undefined);
      setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: "" });
      props.toast.current.show({ severity: "error", content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
    }
    setLoading(false);
  };

  const fillSub = async (identity: string, isID: boolean) => {
    setLoading(true);
    let query = `req_id=${props.singleData.req_ID}&`;
    if (isID) query += `consultant_id=${control._formValues.identity}`;
    else query += `consultant_email=${control._formValues.identity}`;
    setUniversity(undefined);

    const responseSub = await Fetch("Consultant_Mast/consultantSub", "GET", null, query, props.toast);
    if (responseSub) {
      const result = await responseSub.json();
      setSubTable({ data: result, open: subTable.open });
    }
    const response = await Fetch("Consultant_Mast", "GET", null, query, props.toast);
    if (response) {
      const _data: Array<IConsultantMast> = await response.json();
      const data = _data[0];
      setEmployerDetails({ data: _data, open: employerDetails.open, consultant_ID: data.consultant_ID });
      reset(data);
      setDisableConsultant(true);

      setValue("identity", data.consultant_Email_ID);
      setValue("state", { state_ID: 1, state_Name: data.consultant_State });
      setValue("city", { city_ID: data.consultant_City || 0, city_Name: data.city_Name || "" });
      setValue("country", { country_ID: data.consultant_Country, country_Name: data.country_Name });
      setValue("company", { vendor_Company_ID: data.vendor_Company_ID, vendor_Company_Name: data.vendor_Company_Name });
      setValue("faceToFaceInterview", false);
      setValue("tax_Term", TaxTerm.C2C_With_Benefits);
      setUniversity({ university_ID: data.university_ID, university_Name: data.university_Name });
      const _dobArray = data.dob?.split("-");
      if (_dobArray) {
        setValue("dobmm", _dobArray[0]);
        setValue("dobdd", _dobArray[1]);
        setValue("dobyyyy", _dobArray[2]);
      }
      setRefCount(_data.length);
      if (_data.length > 1) {
        _data.forEach((d, i) => {
          if (i === 0) {
            setValue("r1_Ref_ID", d.r1_Ref_ID);
            setValue("r1_Company_Name", d.r1_Company_Name);
            setValue("r1_POC_Name", d.r1_POC_Name);
            setValue("r1_Phone", d.r1_Phone);
            setValue("r1_Email", d.r1_Email);
          } else if (i === 1) {
            setValue("r2_Ref_ID", d.r1_Ref_ID);
            setValue("r2_Company_Name", d.r1_Company_Name);
            setValue("r2_POC_Name", d.r1_POC_Name);
            setValue("r2_Phone", d.r1_Phone);
            setValue("r2_Email", d.r1_Email);
          } else if (i === 2) {
            setValue("r3_Ref_ID", d.r1_Ref_ID);
            setValue("r3_Company_Name", d.r1_Company_Name);
            setValue("r3_POC_Name", d.r1_POC_Name);
            setValue("r3_Phone", d.r1_Phone);
            setValue("r3_Email", d.r1_Email);
          }
        });
      }
    } else {
      reset(EmptySubmission);
      setDisableConsultant(false);
      setValue("identity", identity);
      !isID && setValue("consultant_Email_ID", identity);
    }
    setLoading(false);
  };

  const fillSubmission = async () => {
    if (control._formValues.identityType === "Email ID") {
      const valid = await emailSchema.isValid({
        email: control._formValues.identity,
      });
      if (valid) {
        const email = control._formValues.identity;
        fillSub(email, false);
      } else props.toast.current.show({ severity: "error", content: "Please Enter a Valid Email-ID" });
    } else if (control._formValues.identityType === "Cons. ID") {
      const valid = await idSchema.isValid({
        id: control._formValues.identity,
      });
      if (valid) {
        const id = control._formValues.identity;
        fillSub(id, true);
      } else props.toast.current.show({ severity: "error", content: "Please Enter a Valid Consultant-ID" });
    }
  };

  const saveToDB = async (body: IConsultantMast) => {
    setLoading(true);
    if (body.dobdd === undefined) body.dobdd = "";
    if (body.dobmm === undefined) body.dobmm = "";
    if (body.dobyyyy === undefined) body.dobyyyy = "";

    const consultant_Data = {
      consultant_ID: body.consultant_ID,
      consultant_Name: body.consultant_Name,
      consultant_Email_ID: body.consultant_Email_ID?.trim().toLowerCase(),
      consultant_Home_No: body.consultant_Home_No,
      consultant_Job_Title: body.consultant_Job_Title,
      visa_Status: body.visa_Status,
      consultant_State: body.state?.state_Name,
      consultant_City: body.city?.city_ID,
      total_Experience: body.total_Experience,
      availability: body.availability,
      hourly_Rate: body.hourly_Rate,
      dob: body.dobmm + "-" + body.dobdd + "-" + body.dobyyyy,
      ssn: body.ssn,
      linkedin: body.linkedin,
      consultant_Country: body.country?.country_ID,
      annual_Salary: body.annual_Salary ? body.annual_Salary : undefined,
      university_Name: body.university_Name,
      degree: body.degree,
      passoutYear: body.passoutYear,
    };

    const consultant_Submittal_Logs: IConsultantMast = {
      requirement_ID: props.singleData.req_ID,
      faceToFaceInterview: body.faceToFaceInterview,
      tax_Term: body.tax_Term,
      payment_Term: body.payment_Term,
      submissionType: body.submissionType,
      buying_Rate: body.hourly_Rate,
      addition_Info: additionInfo,
      req_Understand_Percentage: sliderValue || 0,
      req_Understood_Comment: (understoodText || "").trim(),
      blacklisted_SV_Sub_Reason: reasonControl._formValues.Requested_Reason === null || (reasonControl._formValues.Requested_Reason || "").trim() === "" ? null : reasonControl._formValues.Requested_Reason,
    };

    const sub_Vendor_Contact_Person_Mast: IConsultantMast = {
      contact_Person_EmailID: body.contact_Person_EmailID,
      contact_Person_Name: body.contact_Person_Name,
      phone_No: body.phone_No,
      vendor_Company_ID: body.company?.vendor_Company_ID,
    };

    const consultant_References_List: Array<IConsultantRef> = [];
    for (let i = 0; i < refCount; i++) {
      if (i === 0) {
        const element: IConsultantRef = {
          ref_ID: body.r1_Ref_ID ? body.r1_Ref_ID : undefined,
          consultant_ID: body.consultant_ID,
          company_Name: body.r1_Company_Name,
          poC_Name: body.r1_POC_Name,
          phone: body.r1_Phone,
          email: body.r1_Email,
        };
        consultant_References_List.push(element);
      } else if (i === 1) {
        const element: IConsultantRef = {
          ref_ID: body.r2_Ref_ID ? body.r2_Ref_ID : undefined,
          consultant_ID: body.consultant_ID,
          company_Name: body.r2_Company_Name,
          poC_Name: body.r2_POC_Name,
          phone: body.r2_Phone,
          email: body.r2_Email,
        };
        consultant_References_List.push(element);
      } else if (i === 2) {
        const element: IConsultantRef = {
          ref_ID: body.r3_Ref_ID ? body.r3_Ref_ID : undefined,
          consultant_ID: body.consultant_ID,
          company_Name: body.r3_Company_Name,
          poC_Name: body.r3_POC_Name,
          phone: body.r3_Phone,
          email: body.r3_Email,
        };
        consultant_References_List.push(element);
      }
    }

    const formData = new FormData();
    formData.append("consultantData", JSON.stringify(consultant_Data));
    formData.append("subVendorContact", JSON.stringify(sub_Vendor_Contact_Person_Mast));
    formData.append("submissionData", JSON.stringify(consultant_Submittal_Logs));
    formData.append("references", JSON.stringify(consultant_References_List));
    formData.append("resume", resumeFile);
    formData.append("visa", visaFile);
    formData.append("understoodAudio", understoodAudioFile);
    const params = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
      body: formData,
    };
    const response = await fetch(
      `${baseUrl}Consultant_Mast/submission/${props.singleData.req_ID}` +
      (props.publish === true ? "?publishSub=true" + (is_Blacklisted ? "&isBlacklistSub=true" : "")
        : is_Blacklisted ? "?isBlacklistSub=true" : ""),
      params,
    );

    if (!response.ok) {
      const message = await response.text();
      props.toast.current.show({ severity: "error", detail: message, life: 3000 });
      setOpenBlack(false);
      setOpenBlackReasonModal(false);
      setLoading(false);
      setIs_Blacklisted(false);
      resetReason({ Requested_Reason: "" });
      return;
    }

    const data = await response.json();

    if (data.openBlacklist === true) {
      setOpenBlack(true);
      setLoading(false);
      return;
    }

    if (data.isTargetCompleted === true) props.ShowCelebration();

    if (data.isRunningPo === true) {
      props.toast.current.show({ severity: "success", content: `Candidate was already in running PO,  and ${data.message}` });
    } else props.toast.current.show({ severity: "success", content: data.message });
    onHide();

    setOpenBlack(false);
    setOpenBlackReasonModal(false);
    setLoading(false);
    setIs_Blacklisted(false);
    setResumeFile(null);
    setVisaFile(null);
    resetReason({ Requested_Reason: "" });
    setLoading(false);
  };

  function onSubmit(data: IConsultantMast) {
    const email = data.contact_Person_EmailID;

    if (is_Blacklisted && (reasonControl._formValues.Requested_Reason === null || (reasonControl._formValues.Requested_Reason || "").trim() === "")) {
      props.toast.current.show({ severity: "error", content: "For Blacklisted Subvendor, Reason Is Required" });
    } else if (!resumeFile) {
      props.toast.current.show({ severity: "error", content: "Please Upload the Consultant Resume First." });
    } else if (!visaFile && data.visa_Status !== 4) {
      props.toast.current.show({ severity: "error", content: "Please Upload the Consultant Visa First." });
    } else if (disableEmployeeDetails) {
      if (resumeFile) saveToDB(data);
      else props.toast.current.show({ severity: "error", content: "Please Upload the Consultant Resume First." });
    } else {
      if (!(email?.includes("gmail") || email?.includes("outlook") || email?.includes("protonmail") || email?.includes("aol") || email?.includes("yahoo") || email?.includes("hotmail") || email?.includes("rediff"))) {
        if (resumeFile) saveToDB(data);
        else props.toast.current.show({ severity: "error", content: "Please Upload the Consultant Resume First." });
      } else {
        setValue("contact_Person_Name", "");
        setValue("phone_No", undefined);
        setValue("vendor_Company_ID", undefined);
        setValue("company", { vendor_Company_ID: 0, vendor_Company_Name: "" });
        props.toast.current.show({ severity: "error", content: "Employer Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc." });
      }
    }
  }

  const onHide = () => {
    setEscalationTableData({ tableData: [], loading: false });
    setOpenEscalationModal({ singleData: {}, open: false });
    setSliderValue(null);
    setUnderstoodText(null);
    props.hideDialog();
    reset(EmptySubmission);
    setDisablePaymentsTerm(true);
    setDisableConsultant(true);
    setRefCount(1);
    setSubTable({ data: [], open: false });
    setAdditionInfo("");
    setResumeFile(null);
    setVisaFile(null);
    setOpenBlackReasonModal(false);
    setOpenBlack(false);
    setOpenBlackReasonModal(false);
    setLoading(false);
  };

  const dFooter = () => {
    return (
      <div className="col-12 md:col-12 flex gap-4 justify-content-end">
        <Button loading={loading} form="submissionForm" label="SAVE" type="submit" style={{ width: "100px" }}></Button>
        <Button
          className="p-button-outlined surface-200"
          style={{ width: "100px" }}
          label="CLEAR"
          onClick={() => {
            reset(EmptySubmission);
            setUniversity(undefined);
            setRefCount(1);
            setSubTable({ data: [], open: false });
            setSliderValue((prev) => (prev = null));
            setUnderstoodText((prev) => (prev = null));
            setUnderstoodAudioFile((prev: any) => (prev = null));
          }}
          type="button"
        ></Button>
      </div>
    );
  };


  const resumeUpload = (event: FileUploadHandlerParam) => {
    const file = event.files[0];
    if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      if (file.size > 1024 * 1024 * 2) {
        props.toast.current.show({ severity: "error", content: "DOCX File should be less than 2 MB." });
        event.options.clear();
        setResumeFile(null);
      } else {
        setResumeFile(file);
        event.options.clear();
      }
    } else {
      props.toast.current.show({ severity: "error", content: "Please Choose A DOCX File." });
      event.options.clear();
      setResumeFile(null);
    }
  };

  const visaUploade = (event: FileUploadHandlerParam) => {
    const file = event.files[0];
    if (file.size > 1024 * 1024 * 2) {
      props.toast.current.show({ severity: "error", content: "File should be less than 2 MB." });
      event.options.clear();
      setVisaFile(null);
    } else {
      setVisaFile(file);
      event.options.clear();
    }
  };

  const handleEmployerSelect = (employer: any) => {
    setValue("contact_Person_EmailID", employer.contact_Person_EmailID);
    setValue("company", { vendor_Company_ID: employer.vendor_Company_ID, vendor_Company_Name: employer.company });
    setValue("contact_Person_Name", employer.contact_Person_Name);
    setValue("phone_No", employer.phone_No);
  };

  const loadReqRepoData = async (reqID: number) => {
    setReqRepoData({ data: reqRepoData.data, loading: true });
    const response = await Fetch("Consultant_Mast/getPVreports", "GET", null, `reqID=${reqID}`, props.toast);
    if (response) {
      const data: IReqRepoDetails = await response.json();

      const newData: IReqRepoDetailsLst[] = [
        { type: "PV Company", noOfReq: data.poC_Company?.noOfReq, noOfSub: data.poC_Company?.noOfSub, noOfECS: data.poC_Company?.noOfECS, noOfECI: data.poC_Company?.noOfECI, noOfPO: data.poC_Company?.noOfPO },
        { type: "POC", noOfReq: data.poc?.noOfReq, noOfSub: data.poc?.noOfSub, noOfECS: data.poc?.noOfECS, noOfECI: data.poc?.noOfECI, noOfPO: data.poc?.noOfPO },
        { type: "POC - Sales Manager", noOfReq: data.poC_Sales?.noOfReq, noOfSub: data.poC_Sales?.noOfSub, noOfECS: data.poC_Sales?.noOfECS, noOfECI: data.poC_Sales?.noOfECI, noOfPO: data.poC_Sales?.noOfPO },
      ];

      setReqRepoData({ data: newData, loading: false });
    } else setReqRepoData({ data: reqRepoData.data, loading: false });
  };

  useEffect(() => {
    if (props.singleData.req_ID !== undefined && props.singleData.req_ID !== null && props.singleData.req_ID !== 0) {
      loadReqRepoData(props.singleData.req_ID);
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Add Consultant" footer={dFooter} className="p-fluid" maximizable onHide={onHide}>
      {data && <Req req={data} />}
      <div className="mt-1">
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          size="small"
          stripedRows
          showGridlines
          responsiveLayout="scroll"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          value={reqRepoData.data}
          emptyMessage="No Requirements found."
          header={<></>}
          loading={reqRepoData.loading}
        >
          <Column field="type" header="Type" />
          <Column field="noOfReq" header="#Req" />
          <Column field="noOfSub" header="#Sub" />
          <Column field="noOfECS" header="#ECS" />
          <Column field="noOfECI" header="#ECI" />
          <Column field="noOfPO" header="#PO" />
        </DataTable>
      </div>
      <form id="submissionForm" onSubmit={handleSubmit(onSubmit)}>
        <div style={{ border: "1px solid #d2d2d2", padding: "10px", marginTop: "1rem" }} className="flex justify-content-between gap-5 ">
          <div className="justify-content-center w-6 mt-1">
            <div>
              How Much Percentage Did You Understood This Requirement ?<span style={{ color: "red" }}>*</span>
            </div>
            <div className="w-9 mt-2">
              <InputText value={`${sliderValue || 0} %`} className="w-full" />
              <Slider value={sliderValue || 0} onChange={(e: any) => setSliderValue(e.value)} className="w-full" />
            </div>
          </div>
          <div className="mt-4 w-6">
            {sliderValue != null && sliderValue >= 0 && <SpeechToText placeHolder="Comment On What Did You Understand" understoodText={understoodText} setValue={setUnderstoodText} setAudioFile={setUnderstoodAudioFile} />}
          </div>
        </div>
        <hr />
        <div style={{ margin: "10px 0", width: "100%", marginTop: "1rem" }}></div>
        <div className="p-fluid formgrid grid">
          <JVDropdown column={3} control={control} name="identityType" options={[{ name: "Email ID" }, { name: "Cons. ID" }]} optionLabel="name" optionValue="name" placeholder="--Select--" />
          <JVInputCheck required func={fillSubmission} control={control} name="identity" />
          {subTable.data.length > 0 && (
            <div className="field col-12 md:col-1">
              <Button
                type="button"
                label={subTable.data.length.toString()}
                className="p-button-rounded p-button-info"
                onClick={() => {
                  if (subTable.data.length > 0) setSubTable({ data: subTable.data, open: true });
                }}
              />
            </div>
          )}
        </div>

        <Accordion multiple activeIndex={[0, 1]}>
          <AccordionTab header="Consultant Required Details:">
            <div className="p-fluid formgrid grid">
              <JVInput required disabled={!_roles.includes(1) && disableConsultant} placeholder="Consultant Name" column={3} control={control} name="consultant_Name" error={errors.consultant_Name?.message} />
              <JVInput required disabled placeholder="Email" column={3} control={control} name="consultant_Email_ID" error={errors.consultant_Email_ID?.message} />
              <JVInputMask required mask="(999) 999-9999" column={3} placeholder="Phone" control={control} name="consultant_Home_No" error={errors.consultant_Home_No?.message} />
              <JVInput required placeholder="Job Title" column={3} control={control} name="consultant_Job_Title" error={errors.consultant_Job_Title?.message} />

              <JVDropdown required column={3} control={control} name="visa_Status" error={errors.visa_Status?.message} options={visa} optionLabel="visa_Name" optionValue="visaId" placeholder="--Select Visa--" />
              <JVDropdown required column={3} control={control} name="visa_Received_By" error={errors.visa_Received_By?.message} options={Visa_Received_By} optionLabel="name" optionValue="value" placeholder="--Select Visa Received By--" />
              <div className="field col-12 md:col-4">
                <FileUpload chooseLabel={visaFile ? visaFile.name + " (" + (visaFile.size / 1024)?.toFixed(1) + " KB)" : "Upload Visa Copy"} style={{ height: "1rem" }} mode="basic" name="visa" auto customUpload uploadHandler={visaUploade} />
              </div>
              <JVDropdownInput required column={3} completeMethod={completeMethodStates} control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />
              <JVDropdownInput required column={3} completeMethod={completeMethodCities} control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />
              <JVDropdown required column={3} control={control} name="total_Experience" error={errors.total_Experience?.message} options={Experience} optionLabel="name" optionValue="name" placeholder="--Select Total Exp--" />

              <JVDropdown required column={3} control={control} name="availability" error={errors.availability?.message} options={NoticePeriod} optionLabel="name" optionValue="value" placeholder="--Select NoticePeriod--" />
              <JVInput required placeholder="Buying Rate" type={"number"} column={3} control={control} name="hourly_Rate" error={errors.hourly_Rate?.message} />
              <JVDropdown required column={3} control={control} name="tax_Term" error={errors.tax_Term?.message} options={Tax_Term} optionLabel="name" optionValue="id" placeholder="--Select TaxTerm--" />
              {!disablePaymentsTerm && <JVDropdown required column={3} disabled={disablePaymentsTerm} control={control} name="payment_Term" error={errors.payment_Term?.message} options={Payment_Term} optionLabel="name" optionValue="id" placeholder="--Select PaymentTerm--" />}
              <JVRadioBtn inline label="F2F Interview" required data={[{ label: "Yes", value: true }, { label: "No", value: false }]} column={3} control={control} name="faceToFaceInterview" error={errors.faceToFaceInterview?.message} />
            </div>
          </AccordionTab>
          {!disableEmployeeDetails && (
            <AccordionTab header="Employer Details:">
              <div className="flex gap-3">
                <Button
                  icon="pi pi-search"
                  type="button"
                  className="p-button-rounded p-button-success mb-2"
                  aria-label="see details"
                  onClick={() => {
                    setEmployerDetails({ data: employerDetails.data, open: true, consultant_ID: employerDetails.consultant_ID });
                  }}
                />
                {control._formValues.vendor_Company_ID !== 0 && control._formValues.vendor_Company_ID > 0 && (
                  <Button
                    className="p-button-rounded"
                    type="button"
                    tooltip="View Escalation"
                    icon="pi pi-eye"
                    onClick={() => {
                      setOpenEscalationModal({ singleData: {}, open: true });
                    }}
                  ></Button>
                )}
              </div>
              <div className="p-fluid formgrid grid">
                <JVInput required disabled={disableEmployeeDetails} onBlur={fillSubVendor} placeholder="Employer Email" column={4} control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />
                <JVDropdownInput
                  required
                  disabled={disableEmployeeDetails}
                  column={4}
                  completeMethod={completeMethodEC}
                  control={control}
                  name="company"
                  error={errors.company?.vendor_Company_ID?.message}
                  options={clientCompanies}
                  optionLabel="vendor_Company_Name"
                  placeholder="Search Employer Company"
                />
                <JVInput required disabled={disableEmployeeDetails} placeholder="Contact Name" column={4} control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <JVInputMask required disabled={disableEmployeeDetails} mask="(999) 999-9999" column={4} placeholder="Employer Phone" control={control} name="phone_No" error={errors.phone_No?.message} />
              </div>
            </AccordionTab>
          )}
          <AccordionTab header="Education & Other Details:">
            <div className="p-fluid formgrid grid">
              <JVInput placeholder="Degree" column={3} control={control} name="degree" error={errors.degree?.message} />
              <div className="field col-12 md:col-4">
                <div className="p-inputgroup">
                  <AutoComplete suggestions={universities} completeMethod={completeMethodUniversities} field="university_Name" value={university} placeholder="Search/Type University" onChange={(e) => setUniversity(e.value)} />
                </div>
                <small className="p-error">{errors.university_Name?.message}</small>
              </div>
              <JVInput placeholder="Passing Year" column={3} control={control} name="passoutYear" error={errors.passoutYear?.message} />
              <JVDropdownInput column={3} completeMethod={completeMethodCountries} control={control} name="country" error={errors.country?.country_ID?.message} options={countries} optionLabel="country_Name" placeholder="Search Country" />

              <div className="field col-12 md:col-4" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <JVInputMask mask="99" column={3} placeholder="MM" control={control} name="dobmm" />
                <JVInputMask mask="99" column={3} placeholder="DD" control={control} name="dobdd" />
                <JVInputMask mask="9999" column={3} placeholder="YYYY" control={control} name="dobyyyy" />
              </div>

              <JVInput placeholder="SSN" column={3} type={"number"} control={control} name="ssn" error={errors.ssn?.message} />
              <JVInput placeholder="Linkedin" column={3} control={control} name="linkedin" error={errors.linkedin?.message} />

              <JVDropdown column={3} control={control} name="submissionType" error={errors.submissionType?.message} options={Submission_Type} optionLabel="name" optionValue="id" placeholder="--Select JobType--" />
              <JVInput placeholder="Salary" type={"number"} column={3} control={control} name="annual_Salary" error={errors.annual_Salary?.message} />
            </div>
          </AccordionTab>
          <AccordionTab header="References:">
            <div className="p-fluid formgrid grid">
              <JVInput placeholder="Company Name" column={4} control={control} name="r1_Company_Name" />
              <JVInput placeholder="POC Name" column={4} control={control} name="r1_POC_Name" />
              <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r1_Phone" />
              <JVInput placeholder="Email" column={4} control={control} name="r1_Email" error={errors.r1_Email?.message} />
            </div>
            {refCount > 1 && (
              <div className="p-fluid formgrid grid">
                <JVInput placeholder="Company Name" column={4} control={control} name="r2_Company_Name" />
                <JVInput placeholder="POC Name" column={4} control={control} name="r2_POC_Name" />
                <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r2_Phone" />
                <JVInput placeholder="Email" column={4} control={control} name="r2_Email" error={errors.r2_Email?.message} />
              </div>
            )}
            {refCount > 2 && (
              <div className="p-fluid formgrid grid">
                <JVInput placeholder="Company Name" column={4} control={control} name="r3_Company_Name" />
                <JVInput placeholder="POC Name" column={4} control={control} name="r3_POC_Name" />
                <JVInputMask mask="(999) 999-9999" column={4} placeholder="Phone" control={control} name="r3_Phone" />
                <JVInput placeholder="Email" column={4} control={control} name="r3_Email" error={errors.r3_Email?.message} />
              </div>
            )}
            {refCount !== 3 && <Button icon="pi pi-plus" type="button" className="p-button-rounded p-button-success" aria-label="Add More" onClick={() => setRefCount(refCount + 1)} />}
          </AccordionTab>
          <AccordionTab header="Additional Info:">
            <div className="p-fluid formgrid grid">
              <div className="col-12 md:col-12 md:col-6">
                <JVSunEditor value={additionInfo} handleChange={setAdditionInfo} />
              </div>
            </div>
          </AccordionTab>
        </Accordion>
        <div className="field col-12 md:col-12">
          <FileUpload chooseLabel={resumeFile ? resumeFile.name + " (" + (resumeFile.size / 1024)?.toFixed(1) + " KB)" : "Choose Resume"} mode="basic" name="resume" accept=".docx" auto customUpload uploadHandler={resumeUpload} />
        </div>
      </form>
      <SubmissionsTable data={subTable.data} hideDialog={hideSubTable} open={subTable.open} toast={props.toast} />
      <EmployerDetails onEmployerSelect={handleEmployerSelect} consultant_ID={employerDetails.consultant_ID} data={employerDetails.data} hideDialog={hideSubTable} open={employerDetails.open} toast={props.toast} />

      <Dialog header="Bypass Blacklist Vendor" style={{ width: "30vw" }} visible={openBlack} modal onHide={() => {
        setOpenBlack(false);
        resetReason({ Requested_Reason: "" });
      }}>
        <p>This Vendor Is Blacklisted</p>
        <p>
          If you still want to submit candidate with this vendor, you can <span className="text-red-600 font-bold">Bypass Vendor</span> for this submission.
        </p>
        <div className="flex justify-content-end gap-5 mt-4">
          <Button label="Yes,I Want to Request" onClick={() => {
            setOpenBlack(false);
            setOpenBlackReasonModal(true);
            setIs_Blacklisted(true);
          }} />
          <Button label="No" onClick={() => {
            setOpenBlack(false);
            setIs_Blacklisted(false);
            resetReason({ Requested_Reason: "" });
          }} />
        </div>
      </Dialog>

      <Dialog header="Bypass Vendor - Reason" visible={openBlackReasonModal} style={{ width: "35vw" }} modal
        onHide={() => {
          setOpenBlackReasonModal(false);
          resetReason({ Requested_Reason: "" });
          setIs_Blacklisted(false);
        }}>
        <form>
          <div className="field col-12 md:col-12 mt-2">
            <label htmlFor="Requested_Reason" className="block font-medium mb-1">
              Reason For Bypass<span style={{ color: "red" }}>*</span>
            </label>

            <Controller name="Requested_Reason" control={reasonControl} rules={{ required: "Reason is required" }} render={({ field }) => <InputTextarea {...field} autoResize className="w-full" style={{ minHeight: "200px" }} rows={6} />} />
            {reasonErrors.Requested_Reason && <p className="p-error">{reasonErrors.Requested_Reason.message}</p>}
          </div>
          <div className="flex justify-content-end gap-5 mt-4">
            <Button type="submit" form="submissionForm" label="Submit" loading={loading} />
          </div>
        </form>
      </Dialog>

      <Dialog visible={openEscalationModal.open} style={{ width: "80vw" }} header="PV Escalation" className="p-fluid" onHide={() => {
        setOpenEscalationModal({ singleData: {}, open: false });
      }}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" value={escalationTableData.tableData} loading={escalationTableData.loading} showGridlines stripedRows responsiveLayout="scroll">
          <Column field="vendor_Type" header="Vendor Type" body={(rowData: IEscalationList) => <p>{rowData.vendor_Type === 1 ? "Prime Vendor" : "Sub Vendor"}</p>} />
          <Column field="vendor_Company_Name" header="Vendor Company" />
          <Column field="added_By" header="Added By" />
          <Column field="company" header="Company" />
          <Column field="branch" header="Branch" />
          <Column field="escalation_Subject" header="Escalation Subject" body={(rowData: any) => (
            <div className="flex">
              <div className={"knob3" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {rowData.escalation_Subject}
                <Tooltip target={".knob3" + rowData.id} position="top" content={`${rowData.escalation_Subject?.trim()}`} />
              </div>
              <span style={{ color: "#2196F3" }}>{rowData.escalation_Subject?.trim().length > 5 ? "..." : ""}</span>
            </div>
          )} />
          <Column field="escalation_Comment" header="Escalation Comment" body={(rowData: any) => (
            <div className="flex">
              <div className={"knob4" + rowData.id} style={{ color: "#2196F3", cursor: "pointer", height: "20px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis" }}>
                {rowData.escalation_Comment}
                <Tooltip target={".knob4" + rowData.id} position="top" content={`${rowData.escalation_Comment?.trim()}`} />
              </div>
              <span style={{ color: "#2196F3" }}>{rowData.escalation_Comment?.trim().length > 5 ? "..." : ""}</span>
            </div>
          )} />
          <Column field="escalation_Status" header="Status" />
        </DataTable>
      </Dialog>
    </Dialog>
  );
};
